import { useMediaQuery } from 'react-responsive'

export const useMediaQueries = () => {
  const isMobile = useMediaQuery({ maxDeviceWidth: 768 })
  const isLargeMobile = useMediaQuery({ minDeviceWidth: 480 })
  const isTablet = useMediaQuery({ minDeviceWidth: 768.1 })
  const isSmallLaptop = useMediaQuery({ minDeviceWidth: 960.1 })
  const isLaptop = useMediaQuery({
    minDeviceWidth: 1024
  })
  const isDesktop = useMediaQuery({
    minDeviceWidth: 1200
  })

  return {
    isMobile,
    isLargeMobile,
    isTablet,
    isSmallLaptop,
    isLaptop,
    isDesktop
  }
}
